import { useCallback } from 'react';
import { EventContent, EventSocialContent } from 'features/events';
import type { EventItem } from '../DeclinedEvents';

export const useCreateEventExtra = () =>
  useCallback(({ item: { event, source } }: { item: EventItem }) => {
    if (source === 'node') {
      return <EventContent event={event} />;
    }

    return <EventSocialContent event={event} />;
  }, []);
